import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { ASSETS } from "@/lib/services";
import RichText from "@/components/RichText";

export default function About() {
  const { t } = useContent();
  return (
    <div data-testid="about-page">
      <section className="bg-ink-800 text-bone-50">
        <div className="section pt-24 pb-20 md:pt-32 md:pb-28 grid md:grid-cols-12 gap-14 items-center">
          <div className="md:col-span-7">
            <div className="eyebrow !text-gold-400 mb-6">{t("about.eyebrow")}</div>
            <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight">
              {t("about.title")}
            </h1>
            <p className="mt-8 text-xl text-bone-100/80 leading-relaxed max-w-2xl font-light">
              {t("about.subtitle")}
            </p>
          </div>
          <div className="md:col-span-5">
            <div className="relative">
              <img
                src={ASSETS.attorneyStanding}
                alt="Vasileios Filippidis portrait"
                className="w-full object-contain aspect-[3/4]"
              />
              <div className="absolute -top-6 -left-6 w-32 h-32 border border-gold-500 hidden md:block" />
            </div>
          </div>
        </div>
      </section>

      <section className="section py-20 md:py-28 grid md:grid-cols-12 gap-12">
        <aside className="md:col-span-4">
          <div className="border-t border-gold-500 pt-8 sticky top-32">
            <div className="eyebrow mb-6">Office</div>
            <p className="text-ink-800 font-serif text-lg leading-snug">{t("contact.address")}</p>
            <div className="mt-8 space-y-2 text-sm text-ink-800/75">
              <a className="block hover:text-gold-600" href={`mailto:${t("contact.email")}`}>
                <i className="fa-solid fa-envelope text-gold-600 mr-2" />
                {t("contact.email")}
              </a>
              <a className="block hover:text-gold-600" href={`tel:${t("contact.phone")}`}>
                <i className="fa-solid fa-phone text-gold-600 mr-2" />
                {t("contact.phone")}
              </a>
            </div>
            <Link to="/contact" className="btn-outline-ink mt-10" data-testid="about-contact-cta">
              Get in touch
            </Link>
          </div>
        </aside>

        <article className="md:col-span-8 max-w-3xl">
          <RichText text={t("about.body")} testId="about-body" />
        </article>
      </section>
    </div>
  );
}
